import labelConstants from "../constants/labelConstants";

export const retrieveLabels = (payload: any) => ({
  type: labelConstants.GET_LABELS_LIST,
  payload,
});

export const addLabel = (payload: any) => ({
  type: labelConstants.ADD_LABEL_REQ,
  payload,
});

export const editLabel = (id: string, payload: any) => ({
  type: labelConstants.EDIT_LABEL_REQUEST,
  id,
  payload,
});

export const deleteLabel = (payload: any) => ({
  type: labelConstants.DELETE_LABEL_REQUEST,
  payload,
});

export const resetLabels = () => ({
  type: labelConstants.RESET_LABELS,
});
